module.exports = __webpack_public_path__ + "static/img/xcx1.4dd879a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/xcx1.png
// module id = kmP+
// module chunks = 63